import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {createRefetchContainer, graphql} from 'react-relay';
import {injectIntl} from 'react-intl';
import {cloneDeep} from 'lodash';
import CustomScrollDiv from '../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import UpcomingTasksTable from '../components/overview-upcoming/upcoming_tasks_table';
import Util from '../forecast-app/shared/util/util';
import {GLOBAL_FILTER_OPERATOR, GLOBAL_FILTER_FIELD, BUTTON_STYLE, BUTTON_COLOR, DATE_PICKER_STYLE, WorkflowCategories, ESTIMATION_UNIT} from '../constants';
import UploadingOverlay from '../forecast-app/shared/components/uploading-overlay/uploading_overlay';
import DatePickerV3 from '../forecast-app/shared/components/date-picker/date_picker_v3';
import Dropdown from '../forecast-app/shared/components/dropdowns/dropdown';
import Button from '../forecast-app/shared/components/buttons/button/button';
import TheEye from '../forecast-app/shared/components/headers/header-bar/TheEye';
import HoursInput from '../forecast-app/shared/components/inputs/hours-input/hours_input_view';
import * as tracking from '../tracking';
import {isClientUser} from '../forecast-app/shared/util/PermissionsUtil';

class globalSearchResultsPage extends Component {
	constructor(props) {
		super(props);
		this.typingTimer = null;
		const {formatMessage} = this.props.intl;
		const taskName = this.props.location && this.props.location.state && this.props.location.state.searchQuery ? this.props.location.state.searchQuery : '';
		const filters = [];
		if (taskName !== '') {
			const onSuccess = errors => {
				this.setState({fetching: false});
			};
			//filters.push({operator: GLOBAL_FILTER_OPERATOR.CONTAINS, field: GLOBAL_FILTER_FIELD.NAME, value: [taskName]});
			const searchQuery = {filters: [{operator: GLOBAL_FILTER_OPERATOR.CONTAINS, field: GLOBAL_FILTER_FIELD.NAME, value: [taskName]}]};
			//searchQuery.filters = filters;
			this.props.relay.refetch(
				{
					searchQuery: searchQuery,
				},
				null,
				onSuccess,
				{force: true}
			);
		}
		this.localStorageVersion = 'global-search-task-results';
		const columnData = localStorage.getItem(this.localStorageVersion) ? JSON.parse(localStorage.getItem(this.localStorageVersion)) : [];
		const ascending = localStorage.getItem('global-search-task-results-sort-ascending') || 'true';
		const sortBy = {
			column: localStorage.getItem('global-search-task-results-sort-column') || null,
			ascending: ascending === 'true',
		};

		this.filterOptions = [
			{value: GLOBAL_FILTER_FIELD.BLOCKED, label: formatMessage({id: 'common.blocked'})},
			{value: GLOBAL_FILTER_FIELD.BUG, label: formatMessage({id: 'common.bug'})},
			{value: GLOBAL_FILTER_FIELD.CREATED_AT, label: formatMessage({id: 'global_filter_field.created_at'})},
			{value: GLOBAL_FILTER_FIELD.DESCRIPTION, label: formatMessage({id: 'common.description'})},
			{value: GLOBAL_FILTER_FIELD.END_DATE, label: formatMessage({id: 'common.end_date'})},
			{value: GLOBAL_FILTER_FIELD.FORECAST, label: formatMessage({id: 'common.estimate'})},
			{value: GLOBAL_FILTER_FIELD.HIGH_PRIORITY, label: formatMessage({id: 'common.high_priority'})},
			{value: GLOBAL_FILTER_FIELD.COMPANY_TASK_ID, label: formatMessage({id: 'common.id'})},
			{value: GLOBAL_FILTER_FIELD.LABELS, label: formatMessage({id: 'common.labels'})},
			{value: GLOBAL_FILTER_FIELD.NAME, label: formatMessage({id: 'common.name'})},
			//{value: GLOBAL_FILTER_FIELD.REMAINING, label: formatMessage({id: 'common.remaining'})},
			{value: GLOBAL_FILTER_FIELD.ROLE, label: formatMessage({id: 'common.role'})},
			{value: GLOBAL_FILTER_FIELD.START_DATE, label: formatMessage({id: 'common.start_date'})},
			{value: GLOBAL_FILTER_FIELD.STATUS, label: formatMessage({id: 'common.status'})},
			{value: GLOBAL_FILTER_FIELD.TIME_REGS, label: formatMessage({id: 'common.time_entries'})},
			{value: GLOBAL_FILTER_FIELD.UPDATED_AT, label: formatMessage({id: 'global_filter_field.updated_at'})},
		];
		if (!isClientUser()) {
			this.filterOptions.unshift({value: GLOBAL_FILTER_FIELD.ASSIGNED, label: formatMessage({id: 'common.assigned'})}, {value: GLOBAL_FILTER_FIELD.BILLABLE, label: formatMessage({id: 'common.billable'})});
		}
		this.textTypeFields = [GLOBAL_FILTER_FIELD.NAME, GLOBAL_FILTER_FIELD.DESCRIPTION];
		this.numericTypeFields = [GLOBAL_FILTER_FIELD.COMPANY_TASK_ID];
		this.dateTypeFields = [GLOBAL_FILTER_FIELD.CREATED_AT, GLOBAL_FILTER_FIELD.END_DATE, GLOBAL_FILTER_FIELD.UPDATED_AT, GLOBAL_FILTER_FIELD.START_DATE];
		this.dropdownTypeFields = [GLOBAL_FILTER_FIELD.ASSIGNED, GLOBAL_FILTER_FIELD.LABELS, GLOBAL_FILTER_FIELD.ROLE, GLOBAL_FILTER_FIELD.STATUS];
		this.booleanTypeFields = [GLOBAL_FILTER_FIELD.BILLABLE, GLOBAL_FILTER_FIELD.BLOCKED, GLOBAL_FILTER_FIELD.BUG, GLOBAL_FILTER_FIELD.HIGH_PRIORITY];
		this.hoursInputFields = [GLOBAL_FILTER_FIELD.FORECAST, GLOBAL_FILTER_FIELD.REMAINING, GLOBAL_FILTER_FIELD.TIME_REGS];

		this.state = {
			fetching: taskName !== '',
			sortBy,
			columns: Util.getOverviewUpcomingOrTaskGlobalSearchColumns(columnData, this.props.viewer.availableFeatureFlags),
			filters,
			showNewSearchCriteria: false,
			newFilterField: null,
			newFilterOperator: null,
			newFilterValue: null,
			searchInputValue: taskName,
			invalidFilterValue: false,
			loading: true,
		};
	}

	componentDidMount() {
		tracking.trackPage('global-search-results');
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (
			(nextProps.location && nextProps.location.state && nextProps.location.state.searchQuery && nextProps.location.state.searchQuery !== '' && (!this.props.location || !this.props.location.state || !this.props.location.state.searchQuery)) ||
			(nextProps.location && nextProps.location.state && this.props.location && this.props.location.state && this.props.location.state.searchQuery !== nextProps.location.state.searchQuery && nextProps.location.state.searchQuery !== '')
		) {
			const searchQuery = nextProps.location.state.searchQuery;
			const currentSearchQuery = this.state.searchInputValue;
			if (searchQuery !== currentSearchQuery) {
				const filters = [{operator: GLOBAL_FILTER_OPERATOR.CONTAINS, field: GLOBAL_FILTER_FIELD.NAME, value: [searchQuery]}];
				this.state.filters.forEach(filter => {
					filters.push(filter);
				});
				this.setState({searchInputValue: searchQuery});
				this.sendRequest(filters);
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.showNewSearchCriteria && !prevState.showNewSearchCriteria) {
			this.fieldDropdown.focusDropdownInput();
		}
	}

	setSortBy(column) {
		let ascending = true;
		if (column === this.state.sortBy.column) {
			ascending = !this.state.sortBy.ascending;
		}
		Util.localStorageSetItem('global-search-task-results-sort-column', column);
		Util.localStorageSetItem('global-search-task-results-sort-ascending', ascending);
		this.setState({sortBy: {column: column, ascending: ascending}});
	}

	handleColumnsFilter(selected) {
		let columns = this.state.columns.map(col => {
			if (col.name === selected.name) {
				return {name: selected.name, checked: !selected.checked, translationId: selected.translationId};
			} else {
				return {name: col.name, checked: col.checked, translationId: col.translationId};
			}
		});
		Util.localStorageSetItem(this.localStorageVersion, JSON.stringify(columns));
		this.setState({columns: columns});
	}

	clearCountdown() {
		if (this.typingTimer !== null) {
			clearTimeout(this.typingTimer);
		}
	}
	startCountdown() {
		this.setState({loading: true});
		this.clearCountdown();
		this.typingTimer = setTimeout(this.doneTyping.bind(this), 500);
	}
	doneTyping() {
		const filters = [];
		this.state.filters.forEach(el => filters.push(el));
		if (this.state.searchInputValue !== '') {
			filters.unshift({operator: GLOBAL_FILTER_OPERATOR.CONTAINS, field: GLOBAL_FILTER_FIELD.NAME, value: [this.state.searchInputValue]});
		}
		this.sendRequest(filters);
	}

	onSearchChange(e) {
		this.setState({searchInputValue: e.target.value});
	}

	sendRequest(queryFilters) {
		this.setState({fetching: true});
		const searchQuery = {};
		const filterValues = [];
		const onSuccess = errors => {
			this.setState({fetching: false, loading: false});
		};
		queryFilters.forEach(filter => {
			if (filter.field === GLOBAL_FILTER_FIELD.ASSIGNED || filter.field === GLOBAL_FILTER_FIELD.LABELS || filter.field === GLOBAL_FILTER_FIELD.ROLE || filter.field === GLOBAL_FILTER_FIELD.STATUS) {
				const formattedFilter = {
					field: filter.field,
					operator: filter.operator,
					value: filter.value.map(el => el.value),
				};
				filterValues.push(formattedFilter);
			} else {
				filterValues.push(filter);
			}
		});
		searchQuery.filters = filterValues;
		this.props.relay.refetch(
			{
				searchQuery: searchQuery,
			},
			null,
			onSuccess,
			{force: true}
		);
	}

	toggleShowNewSearchCriteria() {
		this.setState({showNewSearchCriteria: !this.state.showNewSearchCriteria});
	}

	addFilter(newFilter) {
		if (newFilter.value !== null && newFilter.value !== undefined && newFilter.value.length && newFilter.operator !== null && newFilter.operator !== undefined && newFilter.field !== null && newFilter.field !== undefined) {
			const filters = this.state.filters;
			filters.push(newFilter);
			this.setState({filters, newFilterValue: null, newFilterField: null, newFilterOperator: null});
			const searchQuery = [...filters];
			if (this.state.searchInputValue !== '') {
				searchQuery.push({operator: GLOBAL_FILTER_OPERATOR.CONTAINS, field: GLOBAL_FILTER_FIELD.NAME, value: [this.state.searchInputValue]});
			}
			tracking.trackEvent('Refine', {_FilterOn: newFilter.field, _FilterCondition: newFilter.operator});
			this.sendRequest(searchQuery);
			if (this.fieldDropdown) {
				this.fieldDropdown.focusDropdownInput();
			}
		}
	}

	removeFilter(indexToRemove) {
		const filters = this.state.filters;
		filters.splice(indexToRemove, 1);
		this.setState({filters});
		const searchQuery = [...filters];
		if (this.state.searchInputValue !== '') {
			searchQuery.push({operator: GLOBAL_FILTER_OPERATOR.CONTAINS, field: GLOBAL_FILTER_FIELD.NAME, value: [this.state.searchInputValue]});
		}
		this.sendRequest(searchQuery);
	}

	filterFieldChange(selected) {
		const value = selected ? selected.value : selected;
		this.setState({newFilterField: value, newFilterOperator: null, newFilterValue: this.booleanTypeFields.includes(value) ? [true] : null});
		this.operatorDropdown.focusDropdownInput();
	}
	filterOperatorChange(selected) {
		const value = selected ? selected.value : selected;
		this.setState({newFilterOperator: value, newFilterValue: this.booleanTypeFields.includes(this.state.newFilterField) ? [true] : null});
		if (this.booleanTypeFields.includes(this.state.newFilterField)) {
			this.refine_section.focus();
		} else if (this.state.newFilterField === null) {
			this.fieldDropdown.focusDropdownInput();
		} else {
			if (this.valueDropdown) {
				this.valueDropdown.focusDropdownInput();
			} else if (this.valueDatePicker) {
				this.refine_section.focus();
			} else if (this.valueInput) {
				this.valueInput.focus();
			}
		}
	}
	filterValueChangeInput(e) {
		const {value} = e.target;
		if (['FORECAST', 'ID', 'TIME_REGS'].includes(this.state.newFilterField)) {
			if (isNaN(value || !isNaN(parseFloat(value)))) {
				this.setState({invalidFilterValue: true});
			} else {
				this.setState({invalidFilterValue: false});
			}
		}
		this.setState({newFilterValue: [value]});
	}

	filterValueChangeDatePicker(date) {
		this.setState({newFilterValue: [date]});
	}
	filterValueChangeDropdown(selected) {
		if (!selected) {
			return;
		}
		let newFilterValue = this.state.newFilterValue ? this.state.newFilterValue : [];
		let selectedValues = this.state.newFilterValue ? this.state.newFilterValue.map(el => el.value) : [];
		if (selectedValues.includes(selected.value)) {
			newFilterValue = newFilterValue.filter(el => el.value !== selected.value);
		} else {
			newFilterValue.push(selected);
		}
		this.setState({newFilterValue});
	}
	getFilterValueDropdownOptions() {
		const {formatMessage} = this.props.intl;
		let options = null;
		if (this.state.newFilterField === GLOBAL_FILTER_FIELD.STATUS) {
			options = [
				{value: WorkflowCategories.TODO, label: formatMessage({id: 'common.to_do'})},
				{value: WorkflowCategories.INPROGRESS, label: formatMessage({id: 'common.in_progress'})},
				{value: WorkflowCategories.DONE, label: formatMessage({id: 'common.done'})},
			];
		} else if (this.state.newFilterField === GLOBAL_FILTER_FIELD.LABELS) {
			options = this.props.viewer.company.labels.edges.map(el => ({value: el.node.id, label: el.node.name}));
		} else if (this.state.newFilterField === GLOBAL_FILTER_FIELD.ASSIGNED) {
			options = this.props.viewer.company.allPersons.edges.map(el => ({value: el.node.id, label: el.node.firstName + ' ' + el.node.lastName}));
		} else if (this.state.newFilterField === GLOBAL_FILTER_FIELD.ROLE) {
			options = this.props.viewer.company.roles.edges.map(el => ({value: el.node.id, label: el.node.name}));
		}
		return options;
	}

	saveFilter() {
		let formattedValues = this.state.newFilterValue;
		if (this.state.newFilterField && this.dateTypeFields.includes(this.state.newFilterField)) {
			// format to dd/MM/yyyy string
			formattedValues = [];
			this.state.newFilterValue.forEach(value => {
				const stringValue = value.format('YYYY-MM-DD');
				formattedValues.push(stringValue);
			});
		}
		const newFilter = {
			field: this.state.newFilterField,
			operator: this.state.newFilterOperator,
			value: formattedValues,
		};

		this.addFilter(newFilter);
	}

	getInputType() {
		switch (this.state.newFilterField) {
			case GLOBAL_FILTER_FIELD.NAME:
				return 'text';
			case GLOBAL_FILTER_FIELD.COMPANY_TASK_ID:
				return 'number';
			default:
				return 'text';
		}
	}

	getValueInput() {
		if (this.state.newFilterField === null || this.booleanTypeFields.includes(this.state.newFilterField)) {
			return null;
		}
		if (this.dropdownTypeFields.includes(this.state.newFilterField)) {
			return (
				<Dropdown
					ref={dropdown => (this.valueDropdown = dropdown)}
					multiSelect={true}
					hideLabel={true}
					placeholder="value"
					options={this.getFilterValueDropdownOptions()}
					value={this.state.newFilterValue ? this.state.newFilterValue.map(el => el.value) : null}
					onChange={this.filterValueChangeDropdown.bind(this)}
					customHeight={30}
					customClasses="value-selector"
					onBlur={this.handleRefineBlur.bind(this)}
				/>
			);
		}
		if (this.dateTypeFields.includes(this.state.newFilterField)) {
			return (
				<DatePickerV3
					ref={datePickerV3 => (this.valueDatePicker = datePickerV3)}
					isSingleDatePicker={true}
					startDate={this.state.newFilterValue && this.state.newFilterValue.length === 1 ? this.state.newFilterValue[0] : null}
					handleDateRangeChange={this.filterValueChangeDatePicker.bind(this)}
					datePickerStyle={DATE_PICKER_STYLE.STANDARD}
					clearable={false}
					customClasses="value-selector"
					onBlur={this.handleRefineBlur.bind(this)}
				/>
			);
		}
		if (this.hoursInputFields.includes(this.state.newFilterField)) {
			return (
				<HoursInput
					value={this.state.newFilterValue && this.state.newFilterValue.length ? this.state.newFilterValue[0] : ''}
					placeholder={this.props.intl.formatMessage({id: 'hours_input.placeholder'})}
					mutation={this.handleBlurHoursInput.bind(this)}
				/>
			);
		}

		return (
			<input
				ref={input => (this.valueInput = input)}
				type={this.getInputType()}
				className={`value-input ${this.state.invalidFilterValue ? 'invalid' : null}`}
				placeholder="value"
				value={this.state.newFilterValue && this.state.newFilterValue.length ? this.state.newFilterValue[0] : ''}
				onChange={this.filterValueChangeInput.bind(this)}
				onBlur={this.handleRefineBlur.bind(this)}
			/>
		);
	}

	focusRefineButton() {
		if (this.refine_button) {
			this.refine_button.focus();
		}
	}
	handleRefineSectionBlur(e) {
		const newTarget = e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
		if (newTarget && newTarget.className !== undefined && newTarget.className !== null && (newTarget.className.includes('calendar') || newTarget.className.includes('previous-control') || newTarget.className.includes('next-control'))) {
			return;
		}
		if (!this.refine_section.contains(newTarget)) {
			this.setState({showNewSearchCriteria: false, newFilterField: null, newFilterOperator: null, newFilterValue: null});
		}
	}
	handleRefineBlur(e) {
		e.stopPropagation();
		const newTarget = e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
		if (newTarget && newTarget.className !== undefined && newTarget.className !== null && newTarget.className.includes('calendar')) {
			return;
		}
		if (!this.refine_section.contains(newTarget)) {
			this.setState({showNewSearchCriteria: false, newFilterField: null, newFilterOperator: null, newFilterValue: null});
		}
	}

	handleBlurHoursInput(value) {
		if (isNaN(value || !isNaN(parseFloat(value)))) {
			this.setState({invalidFilterValue: true, newFilterValue: null});
		} else {
			this.setState({invalidFilterValue: false, newFilterValue: [value]});
		}
	}

	getOperatorsOptions() {
		const {formatMessage} = this.props.intl;
		const operators = [];
		if (this.state.newFilterField !== GLOBAL_FILTER_FIELD.ROLE && this.state.newFilterField !== GLOBAL_FILTER_FIELD.STATUS && this.dropdownTypeFields.includes(this.state.newFilterField)) {
			operators.push({value: GLOBAL_FILTER_OPERATOR.IN, label: formatMessage({id: 'global_filter_operator.in'})});
			operators.push({value: GLOBAL_FILTER_OPERATOR.NOT_IN, label: formatMessage({id: 'global_filter_operator.not_in'})});
		} else if (this.state.newFilterField !== GLOBAL_FILTER_FIELD.DESCRIPTION) {
			operators.push({value: GLOBAL_FILTER_OPERATOR.IS, label: formatMessage({id: 'global_filter_operator.is'})});
			operators.push({value: GLOBAL_FILTER_OPERATOR.IS_NOT, label: formatMessage({id: 'global_filter_operator.is_not'})});
		}
		if (this.textTypeFields.includes(this.state.newFilterField)) {
			operators.push({value: GLOBAL_FILTER_OPERATOR.CONTAINS, label: formatMessage({id: 'global_filter_operator.contains'})});
			operators.push({value: GLOBAL_FILTER_OPERATOR.CONTAINS_NOT, label: formatMessage({id: 'global_filter_operator.contains_not'})});
		}
		if (this.numericTypeFields.includes(this.state.newFilterField) || this.dateTypeFields.includes(this.state.newFilterField) || this.hoursInputFields.includes(this.state.newFilterField)) {
			operators.push({value: GLOBAL_FILTER_OPERATOR.GREATER, label: formatMessage({id: 'global_filter_operator.greater_than'})});
			operators.push({value: GLOBAL_FILTER_OPERATOR.GREATER_OR_EQUAL, label: formatMessage({id: 'global_filter_operator.equal_greater_than'})});
			operators.push({value: GLOBAL_FILTER_OPERATOR.LESS, label: formatMessage({id: 'global_filter_operator.less_than'})});
			operators.push({value: GLOBAL_FILTER_OPERATOR.LESS_OR_EQUAL, label: formatMessage({id: 'global_filter_operator.equal_less_than'})});
		}

		return operators;
	}

	exportToCSV() {
		const {formatDate} = this.props.intl;
		const isColChecked = new Map();
		const columns = [];
		this.state.columns
			.filter(col => col.checked && col.name !== 'comments/files')
			.forEach(c => {
				let name = '';
				if (c.name === 'id' || c.name === 'name') {
					name = c.name === 'id' ? 'task_id' : 'task_name';
				} else {
					name = c.name.includes(' ') ? c.name.replace(' ', '_') : c.name;
				}
				isColChecked.set(name, true);
				columns.push(name);
			});
		const convertedNum = (num, estimationUnit, minsPerPoint) => Math.round((estimationUnit === ESTIMATION_UNIT.HOURS ? num / 60 : (num * minsPerPoint) / 60) * 10) / 10;
		const data = this.props.viewer.globalSearchTaskResults.edges.map(task => {
			const row = {};
			if (isColChecked.get('project')) {
				row.project = task.node.project.companyProjectId;
			}
			if (isColChecked.get('project_name')) {
				row.project_name = task.node.project.name;
			}
			if (isColChecked.get('task_id')) {
				row.task_id = task.node.companyTaskId;
			}
			if (isColChecked.get('task_name')) {
				row.task_name = task.node.name;
			}
			if (isColChecked.get('status')) {
				row.status = task.node.statusColumnV2.name;
			}
			if (isColChecked.get('start_date')) {
				row.start_date = task.node.startYear ? formatDate(Util.CreateNonUtcMomentDate(task.node.startYear, task.node.startMonth, task.node.startDay)) : ' ';
			}
			if (isColChecked.get('deadline')) {
				row.deadline = task.node.deadlineYear ? formatDate(Util.CreateNonUtcMomentDate(task.node.deadlineYear, task.node.deadlineMonth, task.node.deadlineDay)) : ' ';
			}
			if (isColChecked.get('milestone')) {
				row.milestone = task.node.phase ? task.node.phase.name : ' ';
			}
			if (isColChecked.get('sprint')) {
				row.sprint = task.node.sprint ? task.node.sprint.name : ' ';
			}
			if (isColChecked.get('low')) {
				row.low = convertedNum(task.node.estimateLow, task.node.project.estimationUnit, task.node.project.minutesPerEstimationPoint);
			}
			if (isColChecked.get('high')) {
				row.high = convertedNum(task.node.estimateHigh, task.node.project.estimationUnit, task.node.project.minutesPerEstimationPoint);
			}
			if (isColChecked.get('forecast')) {
				row.forecast = convertedNum(task.node.estimateForecast, task.node.project.estimationUnit, task.node.project.minutesPerEstimationPoint);
			}
			if (isColChecked.get('time_entries')) {
				row.time_entries = task.node.timeRegistrations.edges.reduce((total, el) => total + el.node.minutesRegistered, 0) / 60;
			}
			if (isColChecked.get('remaining')) {
				row.remaining = convertedNum(task.node.timeLeft, task.node.project.estimationUnit, task.node.project.minutesPerEstimationPoint);
			}
			if (isColChecked.get('over_forecast')) {
				const formattedForecast = task.node.project.estimationUnit === ESTIMATION_UNIT.HOURS ? task.node.estimateForecast : task.node.estimateForecast * task.node.project.minutesPerEstimationPoint;
				const overForecast = (formattedForecast - task.node.timeRegistrations.edges.reduce((total, timeReg) => total + timeReg.node.minutesRegistered, 0)) * -1;
				row.over_forecast = overForecast > 0 ? convertedNum(overForecast, task.node.project.estimationUnit, task.node.project.minutesPerEstimationPoint) : 0;
			}
			if (isColChecked.get('over_high')) {
				const formattedHighEstimate = task.node.project.estimationUnit === ESTIMATION_UNIT.HOURS ? task.node.estimateHigh : task.node.estimateHigh * task.node.project.minutesPerEstimationPoint;
				const overHighEstimate = (formattedHighEstimate - task.node.timeRegistrations.edges.reduce((total, timeReg) => total + timeReg.node.minutesRegistered, 0)) * -1;
				row.over_high = overHighEstimate > 0 ? convertedNum(overHighEstimate, task.node.project.estimationUnit, task.node.project.minutesPerEstimationPoint) : 0;
			}
			if (isColChecked.get('client')) {
				row.client = task.node.project.client ? task.node.project.client.name : ' ';
			}
			if (isColChecked.get('assigned')) {
				row.assigned = task.node.assignedPersons.length ? task.node.assignedPersons.map((el, index) => `${el.firstName} ${el.lastName}`).join(', ') : ' ';
			}
			if (isColChecked.get('labels')) {
				row.labels = task.node.taskLabels.length ? task.node.taskLabels.map(el => el.label.name).join(', ') : ' ';
			}
			return row;
		});
		let exportData = columns + '\r\n';
		exportData += Util.JSONToCSV(data);
		Util.exportToCSV(exportData, 'global-search-results.csv');
	}

	handleKeyPress(e) {
		if (e.keyCode === 27) {
			if (this.state.showNewSearchCriteria) {
				this.setState({showNewSearchCriteria: false, newFilterValue: null, newFilterField: null, newFilterOperator: null});
			}
		} else if ((e.keyCode === 32 || e.keyCode === 13) && this.state.showNewSearchCriteria === false) {
			this.setState({showNewSearchCriteria: true});
		} else if (e.keyCode === 13) {
			// Enter, save the filter if there is one
			if (this.state.newFilterValue) {
				this.saveFilter();
			}
		}
	}

	onCloseButtonClick() {
		this.setState({searchInputValue: ''});
	}

	render() {
		const {formatMessage} = this.props.intl;
		const tasks = cloneDeep(this.props.viewer.globalSearchTaskResults.edges);
		Util.sortTasks(tasks, this.state.sortBy);
		const columnOptions = this.state.columns.filter(col => col.name !== 'project');
		const buttonDisabled = this.state.newFilterField === null || this.state.newFilterOperator === null || this.state.newFilterValue === null || this.state.newFilterValue.length === 0 || false;
		return (
			<div className="global-search-results-page">
				{this.props.children}
				<div className={'header' + (tasks.length !== 0 ? ' border-bottom' : '')}>
					<div className="header-columns-wrapper">
						<div className="header-top-row">
							<div className="back-button-input-wrapper">
								<button className="back-button" onClick={this.props.history.goBack} />
								<input className="header-search-input" ref={e => (this.search_input = e)} value={this.state.searchInputValue} onKeyUp={this.startCountdown.bind(this)} onChange={this.onSearchChange.bind(this)} />
								<button id="global-search-clear-icon" className={'global-search-clear-icon' + (this.state.searchInputValue?.length !== 0 ? ' visible' : '')} onClick={this.onCloseButtonClick.bind(this)} />
							</div>
							<section onKeyDown={this.handleKeyPress.bind(this)} className="add-search-criteria-controls-wrapper" ref={e => (this.refine_section = e)} onBlur={this.handleRefineSectionBlur.bind(this)} tabIndex={0}>
								{/* TODO completly remove the logic if no one miss this button

								<button ref={div => (this.refine_button = div)} className={'add-search-criteria-button' + (this.state.showNewSearchCriteria ? ' expanded' : '')} onClick={this.toggleShowNewSearchCriteria.bind(this)}>
									{formatMessage({id: 'common.refine'})}
								</button> */}
								{this.state.showNewSearchCriteria ? (
									<div className="new-search-criteria-controls">
										<div className="new-search-criteria-row">
											<Dropdown
												ref={dropdown => (this.fieldDropdown = dropdown)}
												hideLabel={true}
												placeholder={formatMessage({id: 'global_search_criteria.new_criteria_placeholder'}) + '...'}
												customClasses="field-selector"
												customHeight={30}
												options={this.filterOptions}
												onChange={this.filterFieldChange.bind(this)}
												value={this.state.newFilterField}
												onBlur={this.handleRefineBlur.bind(this)}
											/>
											<Dropdown
												ref={dropdown => (this.operatorDropdown = dropdown)}
												hideLabel={true}
												customHeight={30}
												placeholder={formatMessage({id: 'common.condition'})}
												// disabled={!this.state.newFilterField}
												customClasses="operator-selector"
												options={this.getOperatorsOptions()}
												onChange={this.filterOperatorChange.bind(this)}
												value={this.state.newFilterOperator}
												onBlur={this.handleRefineBlur.bind(this)}
											/>
										</div>
										<div className="new-search-criteria-row bottom">
											{this.getValueInput()}
											<Button
												ref={button => (this.saveButton = button)}
												isDisabled={buttonDisabled}
												symbolClass="plus-white"
												symbolSize="18px"
												buttonStyle={BUTTON_STYLE.FILLED}
												colorTheme={buttonDisabled ? BUTTON_COLOR.MEDIUMGREY : BUTTON_COLOR.GREEN}
												onClick={this.saveFilter.bind(this)}
												className="save-filter-button"
												onBlur={this.handleRefineBlur.bind(this)}
											/>
										</div>
									</div>
								) : null}
							</section>
						</div>
						<div className="header-bottom-row">
							{this.state.filters
								.filter(el => !el.hide)
								.map((el, index) => (
									<div key={index} className="added-search-criteria" title={`${el.field.toLowerCase()} ${el.operator.toLowerCase()} #${el.value.map(v => (v.label ? v.label : v))}`}>
										<div className="text-wrapper">
											<div className="field-and-operator">
												<span className="field">{el.field.toLowerCase()}</span>
												<span>{el.operator.toLowerCase()}</span>
											</div>
											<span className="value">{`#${el.value.map(v => (v.label ? v.label : v))}`}</span>
										</div>
										<button onClick={this.removeFilter.bind(this, index)} className="remove-search-criteria-button" />
									</div>
								))}
						</div>
					</div>
				</div>
				<CustomScrollDiv className="custom-scrollbar-div">
					<div className="body">
						{tasks.length ? (
							<div className="body-top-controls">
								<TheEye openRight={true} options={columnOptions} onSelect={this.handleColumnsFilter.bind(this)} />
								<button className="csv-button" onClick={this.exportToCSV.bind(this)} />
								<span className="results-info-message">
									{formatMessage(
										{id: 'global_search_results_page.results_count_info'},
										{
											count: this.props.viewer.globalSearchTaskResults.edges.length > 200 ? '200 +' : this.props.viewer.globalSearchTaskResults.edges.length,
											value: this.state.searchInputValue,
										}
									)}
								</span>
							</div>
						) : null}

						{this.state.fetching ? (
							<UploadingOverlay />
						) : tasks.length ? (
							<UpcomingTasksTable
								tasks={tasks.length > 200 ? tasks.slice(0, 199) : tasks}
								listOverflowWidth={null}
								columns={this.state.columns}
								sortBy={this.state.sortBy}
								setSortBy={this.setSortBy.bind(this)}
								showTaskModal={taskId => Util.showTaskModal(taskId, this.props.history)}
								viewerId={this.props.viewer.id}
							/>
						) : this.state.searchInputValue && !tasks.length && !this.state.loading ? (
							<div className="global-search-page-no-results">
								<span className="info">{formatMessage({id: 'global_search_results_page.no_results_part_one'})}</span>
								<span className="info">{formatMessage({id: 'global_search_results_page.no_results_part_two'}, {searchQuery: this.state.searchInputValue})}</span>
								<img alt="No results found" src={require('../images/empty-states/Bobbo-the-bear.svg')} />
							</div>
						) : (
							<div className="global-search-page-empty-state-container">
								<span className="info">{formatMessage({id: 'global_search_results_page.no_search_criteria_empty_state_part_one'})}</span>
								<span className="info">{formatMessage({id: 'global_search_results_page.no_search_criteria_empty_state_part_two'})}</span>
								<img className="projects overview" src={require('../images/empty-states/pirate.svg')} alt="global-search-page-empty-state" />
							</div>
						)}
					</div>
				</CustomScrollDiv>
			</div>
		);
	}
}

const globalSearchResultsPageQuery = graphql`
	query globalSearchResultsPage_Query($searchQuery: TaskSearchQueryType) {
		viewer {
			actualPersonId
			component(name: "global_search_results")
			...globalSearchResultsPage_viewer @arguments(searchQuery: $searchQuery)
		}
	}
`;

export {globalSearchResultsPageQuery};

export default withRouter(
	injectIntl(
		createRefetchContainer(
			globalSearchResultsPage,
			{
				viewer: graphql`
					fragment globalSearchResultsPage_viewer on Viewer @argumentDefinitions(searchQuery: {type: "TaskSearchQueryType"}) {
						id
						availableFeatureFlags {
							key
						}
						company {
							roles(first: 10000) {
								edges {
									node {
										id
										name
									}
								}
							}
							labels(first: 10000) {
								edges {
									node {
										id
										name
									}
								}
							}
							allPersons(first: 10000, onlyActive: true) {
								edges {
									node {
										id
										firstName
										lastName
									}
								}
							}
						}
						globalSearchTaskResults(first: 1000, searchQuery: $searchQuery) {
							edges {
								node {
									id
									companyTaskId
									name
									progress
									approved
									timeLeft
									estimateForecast
									estimateHigh
									estimateLow
									startYear
									startMonth
									startDay
									deadlineDay
									deadlineMonth
									deadlineYear
									deadlineFrom
									done
									blocked
									bug
									hasDependency
									canStart
									canBeSetToDone
									highPriority
									estimateForecastPrice
									currentPrice
									role {
										id
										name
									}
									sprint {
										id
										name
										endYear
										endMonth
										endDay
									}
									assignedPersons {
										id
										firstName
										lastName
										profilePictureId
										profilePictureDefaultId
										active
										role {
											id
											name
										}
									}
									taskLabels {
										id
										label {
											id
											name
											color
										}
									}
									timeRegistrations(first: 10000) {
										edges {
											node {
												id
												minutesRegistered
											}
										}
									}
									statusColumnV2 {
										id
										name
										category
									}
									project {
										id
										name
										companyProjectId
										estimationUnit
										remainingAutoCalculated
										minutesPerEstimationPoint
										projectColor
										projectEndYear
										projectEndMonth
										projectEndDay
										client {
											id
											name
										}
									}
									phase {
										name
										deadlineYear
										deadlineMonth
										deadlineDay
									}
									thisTaskDependsOn(first: 1000) @connection(key: "Task_thisTaskDependsOn") {
										edges {
											node {
												id
												type
												thisDependsOnTask {
													id
													name
													deadlineYear
													deadlineMonth
													deadlineDay
													startYear
													startMonth
													startDay
												}
											}
										}
									}
									commentCount
									fileCount
									subTaskCount
								}
							}
						}
					}
				`,
			},
			graphql`
				query globalSearchResultsPageRefetchQuery($searchQuery: TaskSearchQueryType) {
					viewer {
						...globalSearchResultsPage_viewer @arguments(searchQuery: $searchQuery)
					}
				}
			`
		)
	)
);
